// extracted by mini-css-extract-plugin
export default {"container":"AuthBox_container__FlDzP","inputRow":"AuthBox_inputRow__7HJcQ","first_row":"AuthBox_first_row__VzoHi","airgap":"AuthBox_airgap__vdDKY","form":"AuthBox_form__IFS7e"};